<template element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" v-loading="loading">
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { usercenterinfo } from '@/api/home'
export default {
  data() {
    return {
      token:'',
      roleId:''
    }
  },
  watch: {},
  methods: {
    
    
    async usercenterinfo() {
      const { data: res } = await usercenterinfo()
      localStorage.setItem('type',res.data.schoolType)
    },
  },
  components: {
    // 声明子组件名字
  },
  created() {
    this.token = this.$route.query.token
    this.roleId = this.$route.query.roleId
    if (this.token !== 'undefined' && this.token) {
      localStorage.setItem('token', this.token)
    }
    if (this.roleId !== 'undefined' && this.roleId) {
      localStorage.setItem('roleId', this.roleId)
    }
   
    if (this.$route.path !== '/user/login') {
      this.usercenterinfo()
    }
    
  },
  computed: {},
  mounted() {
    //			window.addEventListener( 'beforeunload', e => this.set() );
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/App.vue